export const LogoWhite = require('../asserts/Image/icon_white.png');
export const LogoBlack = require('../asserts/Image/icon_black.png');

export const N = require('../asserts/Image/NoaWen/n.png');
export const O = require('../asserts/Image/NoaWen/o.png');

export const A = require('../asserts/Image/NoaWen/a.png');
export const W = require('../asserts/Image/NoaWen/w.png');

export const E = require('../asserts/Image/NoaWen/e.png');

export const N2 = require('../asserts/Image/NoaWen/n2.png');

export const GreenBack = require('../asserts/Image/greenBack.png');

export const RedDoor = require('../asserts/Image/redDoor.png');

export const LeftFlower = require('../asserts/Image/FLOWER2.png');

export const RightTopFlower = require('../asserts/Image/FLOWER1.png');

export const TopFlower = require('../asserts/Image/FLOWER3.png');

export const RightBottomFlower = require('../asserts/Image/FLOWER4.png');

export const Cursor = require('../asserts/Image/cursor.gif');

export const DoorImage = require('../asserts/Image/DoorImage.png');

export const Graphic1 = require('../asserts/Image/DoorImage.png');


const Images = {
  LogoWhite,
  LogoBlack,
  Cursor,
};

export default Images;
